export default __webpack_public_path__ + "static/media/icon-fb.1575f6be.svg";